import { render, staticRenderFns } from "./CustomerComments.vue?vue&type=template&id=1520d40b&scoped=true"
import script from "./CustomerComments.vue?vue&type=script&lang=js"
export * from "./CustomerComments.vue?vue&type=script&lang=js"
import style0 from "./CustomerComments.vue?vue&type=style&index=0&id=1520d40b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520d40b",
  null
  
)

export default component.exports